import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-focus-topic",
  "use": "icon-focus-topic-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-focus-topic\">\n<g transform=\"translate(12,12) scale(1.7) translate(-12,-12)\">\n<path d=\"M12 6.2L13.41 10.06L17.52 10.21L14.28 12.74L15.41 16.69L12 14.4L8.59 16.69L9.72 12.74L6.48 10.21L10.59 10.06Z\" stroke=\"#1A365D\" stroke-width=\"0.8\" stroke-linejoin=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol